import { Injectable } from '@angular/core';
import moment, { Moment } from 'moment';
import { LuceneExpression } from 'lucene';

@Injectable({ providedIn: 'root' })
export class LuceneService {
	create(fieldName: string, value: string, quotes = false) {
		return {
			field: fieldName,
			term: value,
			quoted: value === '' || quotes
		};
	}

	createFromDate(fieldName: string, from: Moment | '*' = moment().subtract(1, 'month'), to: Moment | '*' = '*') {
		return <const> {
			field: fieldName,
			term_min: from === '*' ? from : from.format(),
			term_max: to === '*' ? to : to.format(),
			inclusive: 'both',
		};
	}

	concat(expr1: LuceneExpression, expr2: LuceneExpression, opr: 'AND' | 'OR' = 'AND', parenthesized = true) {
		return <const> {
			left: expr1,
			operator: opr,
			right: expr2,
			parenthesized,
		};
	}

	concatAll(fieldName: string, values: string[], opr: 'AND' | 'OR' = 'OR', parenthesized = true) {
		if (values.length === 1) {
			return this.create(fieldName, values[0]);
		}
		let expressionArray = this.concat(
			this.create(fieldName, values[0]),
			this.create(fieldName, values[1]),
			opr,
			parenthesized
		);
		for (let i = 2; i < values.length; i++) {
			expressionArray = this.concat(
				expressionArray,
				this.create(fieldName, values[i]),
				opr,
				parenthesized
			);
		}
		return expressionArray;
	}

	createImplicit(fieldName: string, values: string[]) {
		let valuesCondition: LuceneExpression;
		if (values.length === 1) {
			valuesCondition = {
				field: fieldName,
				term: values[0],
				quoted: true
			};
		} else {
			valuesCondition = {
				field: fieldName,
				left: {
					field: '<implicit>',
					term: values[0],
					quoted: true
				},
				operator: '<implicit>',
				right: {
					field: '<implicit>',
					term: values[1],
					quoted: true
				},
				parenthesized: true
			};
			let current = valuesCondition;
			for (const value of values.slice(2)) {
				current.right = {
					left: current.right,
					operator: '<implicit>',
					right: {
						field: '<implicit>',
						term: value,
						quoted: true
					},
					parenthesized: false
				};
				current = current.right;
			}
		}
		return valuesCondition;
	}
}
